export class HistorialNotificacionDTO
{
    fechaHora:Date;
    destinatarios: string[];
    cuerpo:string;
    linkAdjunto:string;
}